export default "__VITE_ASSET__dV0L1Uy4__"